import { render, staticRenderFns } from "./CuponeraModelAddComponent.vue?vue&type=template&id=06ac273a&"
import script from "./CuponeraModelAddComponent.vue?vue&type=script&lang=js&"
export * from "./CuponeraModelAddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports